var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58175 16.4183 4.00003 12 4.00003C7.58172 4.00003 4 7.58175 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5229 22 12C22 6.47718 17.5228 2.00003 12 2.00003C6.47715 2.00003 2 6.47718 2 12C2 17.5229 6.47715 22 12 22ZM10.9993 13.25H6.74967L5.99967 12.25L6.74967 11.25L10.9993 11.25V6.75001L11.9993 6.00001L12.9993 6.75001V11.25L17.2497 11.25L17.9997 12.25L17.2497 13.25H12.9993V17.25L11.9993 18L10.9993 17.25V13.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.f73eae922374cc885a7e68a2caa44d76.svg";
export { ForwardRef as ReactComponent };